export default __webpack_public_path__ + "static/amazon-black-friday-49dbc5f1f656bdebcdcc7e8680310073.png";